import { render, staticRenderFns } from "./ExamLayout.vue?vue&type=template&id=bb1bd536&scoped=true"
import script from "./ExamLayout.vue?vue&type=script&lang=js"
export * from "./ExamLayout.vue?vue&type=script&lang=js"
import style0 from "./ExamLayout.vue?vue&type=style&index=0&id=bb1bd536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1bd536",
  null
  
)

export default component.exports